export default __webpack_public_path__ + "static/media/discord (8).9125c4a9.png";